import { Component, computed, EventEmitter, Input, Output, signal } from '@angular/core';
import { debounce } from '../../../_core/utils/debounce';

@Component({
  selector: 'opac-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent {
  readonly internalValue = signal<string>('');

  /**
   * Debounce timeout to emit search event
   */
  @Input() timeout = 300;
  /**
   * Search input value
   */
  @Input() set value(v) {
    this.internalValue.set(v);
  };
  /**
   * Emits when value changes and debounce is applied
   */
  @Output() search = new EventEmitter<string>();

  readonly debounceFunction = debounce((value: string) => {
    this.search.emit(value);
  }, this.timeout);
  readonly inputIcon = computed(() => this.internalValue() === '' ? 'search' : 'close');

  handleIconClick() {
    if (this.internalValue() !== '') {
      this.internalValue.set('');
      this.search.emit('');
    }
  }


  onValueChanges(value: string): void {
    this.debounceFunction(value);
  }

  updateInternalValue(event: Event) {
    this.internalValue.set((event.target as HTMLInputElement).value);
  }

  onSubmit(event: Event) {
    event.preventDefault();
  }
}
